export default __webpack_public_path__ + "static/media/inves-web.49c6a0e3.png";